import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import FloatingCTA from "@/components/feature/FloatingCTA";
import SEO from "@/components/feature/SEO";
import { organizationSchema, localBusinessSchema, webpageSchema, breadcrumbSchema, reviewSchema, siteUrl } from "@/lib/schemas";
import { testimonials } from "@/mocks/testimonials";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import TrustSection from "./components/TrustSection";
import StatsSection from "./components/StatsSection";
import TestimonialsSection from "./components/TestimonialsSection";
import ClaimsPreviewSection from "./components/ClaimsPreviewSection";
import CTASection from "./components/CTASection";

export default function Home() {
  const baseUrl = siteUrl;
  const reviewData = testimonials.slice(0, 5).map((t) => ({
    author: t.name,
    rating: t.rating,
    reviewBody: t.text,
    datePublished: "2024-01-15",
  }));

  const schemas = [
    webpageSchema(
      "ExpertAdvise.in | Insurance Simplified. Expert Advice. Lifetime Support.",
      "Compare Health, Term, Life, Car, Travel, Marine & Corporate Insurance. Get expert advice, compare plans, use calculators & claim assistance. Call +91 99993 65655.",
      baseUrl
    ),
    organizationSchema(),
    localBusinessSchema(),
    breadcrumbSchema([{ name: "Home", url: baseUrl }]),
    reviewSchema(reviewData),
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="ExpertAdvise.in | Insurance Simplified. Expert Advice. Lifetime Support."
        description="Compare Health, Term, Life, Car, Travel, Marine & Corporate Insurance plans. Get expert guidance, instant quotes, free consultation & lifetime claim support. India's most trusted insurance advisory."
        keywords="best health insurance India, term insurance advisor, insurance consultant, compare insurance plans, insurance claim assistance, mutual fund advisor, financial planner, insurance advisor near me"
        canonical={baseUrl}
        schemas={schemas}
      />
      <Navbar />
      <main>
        <HeroSection />
        <ServicesSection />
        <TrustSection />
        <StatsSection />
        <TestimonialsSection />
        <ClaimsPreviewSection />
        <CTASection />
      </main>
      <Footer />
      <FloatingCTA />
    </div>
  );
}